import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractReversiRules } from '../common/AbstractReversiRules';
export class ToricReversiRules extends AbstractReversiRules {
    static singleton = MGPOptional.empty();
    static get() {
        if (ToricReversiRules.singleton.isAbsent()) {
            ToricReversiRules.singleton = MGPOptional.of(new ToricReversiRules());
        }
        return ToricReversiRules.singleton.get();
    }
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Toric Reversi`,
        config: {
            width: new NumberConfig(8, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(3, 99)),
            height: new NumberConfig(8, RulesConfigDescriptionLocalizable.HEIGHT, MGPValidators.range(3, 99)),
            toric: new BooleanConfig(true, RulesConfigDescriptionLocalizable.TORIC),
        },
    });
    getRulesConfigDescription() {
        return ToricReversiRules.RULES_CONFIG_DESCRIPTION;
    }
}
